export const videosData = [
  {
    id: "docsai-promo",
    title: "DocsAI Promotional Overview",
    product: "DocsAI",
    category: "Promotional",
    format: "MP4 · 1080p HD",
    size: "44.2 MB",
    src: "/images/DocsAI Promotional Video.mp4",
    fileName: "DocsAI Promotional Video.mp4",
    description:
      "Comprehensive product walkthrough demonstrating automated unstructured document parsing, OCR intelligence, and multi-format enterprise ingestion.",
    updatedAt: "Aug 20, 2026",
  },
  {
    id: "docsai-financial",
    title: "DocsAI Financial Document Extractor",
    product: "DocsAI",
    category: "Product Demo",
    format: "MP4 · 1080p HD",
    size: "35.6 MB",
    src: "/images/DocsAI-FinancialExtractor.mp4",
    fileName: "DocsAI-FinancialExtractor.mp4",
    description:
      "Live demonstration of parsing complex balance sheets, invoices, tax statements, and structured financial tables with 99.4% accuracy.",
    updatedAt: "Aug 20, 2026",
  },
  {
    id: "engageai-cs",
    title: "EngageAI Autonomous Customer Service",
    product: "EngageAI",
    category: "Product Demo",
    format: "MP4 · 1080p HD",
    size: "30.4 MB",
    src: "/images/EngageAI-for-Customer Service.mp4",
    fileName: "EngageAI-for-Customer Service.mp4",
    description:
      "Real-time conversational AI assistant resolving customer inquiries, answering complex domain questions, and automating support workflows.",
    updatedAt: "Aug 20, 2026",
  },
  {
    id: "engageai-ordering",
    title: "EngageAI Smart Ordering Assistant",
    product: "EngageAI",
    category: "Product Demo",
    format: "MP4 · 1080p HD",
    size: "15.1 MB",
    src: "/images/EngageAI-for-smart-ordering.mp4",
    fileName: "EngageAI-for-smart-ordering.mp4",
    description:
      "Interactive conversational ordering experience for retail and hospitality, processing items, modifiers, and cart updates seamlessly.",
    updatedAt: "Aug 20, 2026",
  },
  {
    id: "engageai-sales",
    title: "EngageAI Sales Intelligence & Analytics",
    product: "EngageAI",
    category: "Product Demo",
    format: "MP4 · 1080p HD",
    size: "46.6 MB",
    src: "/images/EngageAI-Sales-Intelligence.mp4",
    fileName: "EngageAI-Sales-Intelligence.mp4",
    description:
      "Automated lead qualification, pipeline intelligence, live CRM synchronization, and predictive customer sentiment tracking.",
    updatedAt: "Aug 20, 2026",
  },
];
